import React from 'react';
import './GameInfoPopup.css';

/** PHP .custom-popup — image info modal with Next/Finish button */
export default function GameInfoPopup({ imageSrc, buttonLabel = 'Next', onNext }) {
  return (
    <div className="ic-game-popup">
      <div className="ic-game-popup-top">
        <div className="ic-game-popup-content">
          <img src={imageSrc} alt="" className="ic-game-popup-img" />
        </div>
        <div className="ic-game-popup-footer">
          <button type="button" className="ic-game-popup-next" onClick={onNext}>
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
